<template>
<div><Topnav/>
  <div class="content">
    <div class="jumbotron text-center">
      <h2>Templates</h2>
      <hr class="bg-dark"/>
      <p>Directly use available templates and modify as required.</p>
    </div>
    <div class="container">
      <Temp></Temp>
    </div>
    
  </div>
  </div>
</template>


<script type="text/javascript">

import Topnav from "@/components/Topnav.vue";
import Temp from "@/components/Templates.vue"

export default {
  name: "Templates",
  components: {
    Topnav,
    Temp
  },
};
</script>
